import { AnswerT } from 'src/api/types/AnswerT';

export const filterAnswers = (category: string, answers: AnswerT[]) => {
  const result = [];
  for (const answer of answers) {
    for (const explanation of answer.explanationSet) {
      if (explanation.category === category) {
        result.push(explanation);
      }
    }
  }
  return result;
};
